import {Context} from 'egg';

import ArticleStore, {IArticleStoreInitConfig} from '../../containers/article/article.store';
import ArticleNewsListStore, {IArticleNewsListStoreInitConfig} from '../../containers/articleNewsList/container/store';
import ShareLineStore, {IShareLineStoreInitData} from '../../containers/shareLine/shareLine.store';
import CommentListStore from '../../containers/commentList/store';
import {CommentPanel} from '../../containers/commentWrap/commentWrap';
import CommentInputStore from '../../containers/commentInput/store';
import CommentWrapStore from '../../containers/commentWrap/commentWrap.store';
import VivnAdStore, { IVivnAdStoreInitConfig } from './temp/vivnAdStore';
import {Language, Country} from '../../../const/env';
import AdvertisingStore from '../../containers/advertising/container/store';

export interface IRootStoreInitialConfig {
  articleStore: IArticleStoreInitConfig;
  advertisingStore: any;
  articleNewsListStore: IArticleNewsListStoreInitConfig;
  shareLineStore?: IShareLineStoreInitData;
  commentInputStore?;
  commentWrapStore?;
  vivnAdStore?: IVivnAdStoreInitConfig;
  useVietnam?: boolean;
  useRussia?: boolean;
  useDFP?: boolean;
}

export default class StoryRootStore {
  public articleStore: ArticleStore;
  public articleNewsListStore: ArticleNewsListStore;
  public advertisingStore: any;
  public shareLineStore: ShareLineStore;
  public commentStore_new: CommentListStore;
  public commentStore_hot: CommentListStore;
  public commentInputStore: CommentInputStore;
  public commentWrapStore: CommentWrapStore;
  public vivnAdStore: VivnAdStore;
  public useVietnam: boolean;
  public useRussia: boolean;
  public useDFP: boolean;
  // public commentStore_mine: CommentListStore;

  constructor(initialState?: IRootStoreInitialConfig) {
    const articleInitData: IArticleStoreInitConfig = this.funcGetInitArticleStore(initialState);
    const newsListInitData: IArticleNewsListStoreInitConfig = this.funcGetInitArticleNewsListStore(initialState);

    this.articleStore = new ArticleStore(this, articleInitData);
    this.articleNewsListStore = new ArticleNewsListStore(this, newsListInitData, initialState && initialState.advertisingStore);
    this.shareLineStore = new ShareLineStore(this, initialState && initialState.shareLineStore);

    const itemId = this.funcGetInitArticleStore(initialState).itemId;
    this.commentStore_hot = new CommentListStore(this, {itemId, type: CommentPanel.hot});
    this.commentStore_new = new CommentListStore(this, {itemId , type: CommentPanel.new});
    this.commentInputStore = new CommentInputStore(this, initialState && initialState.commentInputStore);
    this.commentWrapStore = new CommentWrapStore(this, initialState && initialState.commentWrapStore);
    // this.commentStore_mine = new CommentListStore(this, this.funcGetInitArticleStore(initialState));

    this.vivnAdStore = new VivnAdStore(this, initialState && initialState.vivnAdStore);
    this.useVietnam = initialState && initialState.useVietnam || false;
    this.useRussia = initialState && initialState.useRussia || false;
    this.advertisingStore = new AdvertisingStore(this, initialState && initialState.advertisingStore);
  }

  public async ssrInit(ctx: Context, initConfig: IRootStoreInitialConfig): Promise<void> {
    await this.articleStore.ssrInit(ctx, {
      itemId: initConfig.articleStore.itemId,
    });
    await this.articleNewsListStore.ssrInit(initConfig.articleNewsListStore, ctx);
    this.shareLineStore.ssrInit(ctx);
    this.commentInputStore.ssrInit(ctx, {itemId: initConfig.articleStore.itemId, commentId: null});
    this.commentWrapStore.ssrInit(ctx);
    this.vivnAdStore.ssrInit(initConfig.vivnAdStore);
    this.useVietnam = ctx.envi.language === Language.vi;
    this.useRussia = ctx.envi.language === Language.ru;
    this.advertisingStore.ssrInit(initConfig.advertisingStore, ctx);
  }

  public toJson() {
    return {
      articleStore: this.articleStore.toJson(),
      articleNewsListStore: this.articleNewsListStore.toJson(),
      shareLineStore: this.shareLineStore.toJson(),
      commentInputStore: this.commentInputStore.toJson(),
      commentWrapStore: this.commentWrapStore.toJson(),
      vivnAdStore: this.vivnAdStore.toJson(),
      useVietnam: this.useVietnam,
      useRussia: this.useRussia,
      advertisingStore: this.advertisingStore.toJson(),
    };
  }

  public funcGetInitArticleStore(initialState?: IRootStoreInitialConfig): IArticleStoreInitConfig {
    let initData: IArticleStoreInitConfig = initialState ? initialState.articleStore : null;
    if (initData === undefined || initData === null) {
      initData = {
        itemId: '',
        story: null,
      };
    }
    return initData;
  }

  public funcGetInitArticleNewsListStore(initialState?: IRootStoreInitialConfig): IArticleNewsListStoreInitConfig {
    let initData: IArticleNewsListStoreInitConfig = initialState ? initialState.articleNewsListStore : null;
    if (initData === undefined || initData === null) {
      initData = {
        articleId: '',
        langAndCountry: 'en-us',
        expectedTotalCount: 30,
        pageSize: 5,
        isShowLoadMoreComponent: false,
      };
    }
    return initData;
  }

}
